import React from "react";
import { motion } from "framer-motion";

const VALUES = [
  { n: "01", title: "15 Years Automotive Experience", body: "Helping customers find vehicles they actually want · without the hassle." },
  { n: "02", title: "Nationwide Vehicle Search", body: "We locate vehicles from multiple sources so you're not limited to one lot." },
  { n: "03", title: "Personalized Service", body: "Every search is customized to your budget, preferences, and timeline." },
  { n: "04", title: "Fair, Real Offers", body: "Selling or trading in? Get a straightforward offer · no lowball games." },
  { n: "05", title: "Treated Like Family", body: "New customers are always welcome. We treat every customer like family from the first call." },
];

export default function WhyStrive() {
  return (
    <section id="why" data-testid="why-section" className="relative py-28 lg:py-40 px-6 lg:px-10 bg-[#0A0A0A] border-t border-[#1c1c1c]">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-baseline gap-4 mb-14">
          <span className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-[#E31E24]">
            (04) · Why Strive
          </span>
          <span className="flex-1 h-px bg-white/15 mt-1" />
        </div>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="font-anton uppercase leading-[0.9] text-[10vw] md:text-[7vw] lg:text-[5.2vw] mb-20 max-w-5xl"
        >
          Family-run. <span className="font-cormorant italic font-medium text-[#E31E24]">Market-wise.</span> Yours.
        </motion.h2>

        <div className="grid grid-cols-12 gap-y-2">
          {VALUES.map((v, i) => (
            <motion.div
              key={v.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.05, ease: [0.7, 0, 0.2, 1] }}
              data-testid={`value-${v.n}`}
              className="col-span-12 border-t border-white/12 py-8 lg:py-10 grid grid-cols-12 gap-4 lg:gap-8 group hover:bg-[#141414]/50 transition-colors"
            >
              <div className="col-span-2 lg:col-span-1 font-mono2 text-white/50 text-sm mt-2">
                · {v.n}
              </div>
              <h3 className="col-span-10 lg:col-span-6 font-anton uppercase text-3xl lg:text-5xl leading-[0.95]">
                {v.title}
              </h3>
              <p className="col-span-12 lg:col-span-5 text-white/65 text-[15px] leading-relaxed lg:pl-8">
                {v.body}
              </p>
            </motion.div>
          ))}
          <div className="col-span-12 border-t border-white/12" />
        </div>
      </div>
    </section>
  );
}
